'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _cmsComponentUtilities = require('@viskan/cms-component-utilities');

var _methods = require('../methods');

var _addToCart = require('./add-to-cart');

var _addToCart2 = _interopRequireDefault(_addToCart);

var _header = require('./header');

var _header2 = _interopRequireDefault(_header);

var _rows = require('./rows');

var _rows2 = _interopRequireDefault(_rows);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var name = 'CMS-Component-SKU-Table';

var initialState = function initialState() {
	return { buylist: {} };
};

var propTypes = {
	getPrice: {
		source: 'getPrice'
	}
};

var handleArticleFetch = function handleArticleFetch(props, setState) {
	if (!props.useArticleInState && props.articleLFNQuery) {
		(0, _methods.fetchArticle)(props.articleLFNQuery, setState);
	}
};

var afterMount = function afterMount(_ref, el, setState) {
	var props = _ref.props;

	handleArticleFetch(props, setState);
};

var afterUpdate = function afterUpdate(_ref2, prevProps, prevState, setState) {
	var props = _ref2.props;

	if (props.useArticleInState !== prevProps.useArticleInState || props.articleLFNQuery !== prevProps.articleLFNQuery) {
		handleArticleFetch(props, setState);
	}
};

var changeBuyList = function changeBuyList(state, setState) {
	return function (sku) {
		return function (event) {
			var key = (0, _methods.getSKUKey)(sku);
			var qty = parseInt(event.target.value, 10);

			setState({
				buylist: _extends({}, state.buylist, _defineProperty({}, key, _extends({}, sku, {
					qty: qty
				})))
			});
		};
	};
};

var render = function render(_ref3, setState) {
	var props = _ref3.props,
	    state = _ref3.state;

	var article = props.useArticleInState ? props.reduxArticle : state.article;
	var compProps = _extends({}, props, {
		article: article,
		getPrice: typeof props.getPrice === 'function' ? props.getPrice : function (price) {
			return price;
		} // Fallback if component is ever mounted outside Streamline tree
	});

	return (0, _cmsComponentUtilities.createCmsComponent)(article ? (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': name },
		(0, _magicVirtualElement2.default)(_header2.default, compProps),
		(0, _magicVirtualElement2.default)(_rows2.default, _extends({}, compProps, { changeBuyList: changeBuyList(state, setState) })),
		(0, _magicVirtualElement2.default)(_addToCart2.default, _extends({}, compProps, { buylist: state.buylist }))
	) : (0, _magicVirtualElement2.default)('noscript', null), props);
};

exports.default = { propTypes: propTypes, afterMount: afterMount, afterUpdate: afterUpdate, render: render, name: name, initialState: initialState };